import { render, staticRenderFns } from "./HandPaper.vue?vue&type=template&id=17994fcc"
import script from "./HandPaper.vue?vue&type=script&lang=js"
export * from "./HandPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports